import { useEffect, useState } from "react";
import styles from "./TelegramPopup.module.scss";

interface TelegramPopupProps {
  onClose: () => void;
}

export function TelegramPopup({ onClose }: TelegramPopupProps) {
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(onClose, 300);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, 5000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`${styles.popup} ${isClosing ? styles.closing : ""}`}>
      <div className={styles.content}>
        <p>Наш Telegram-канал с новостями и обновлениями!</p>
        <button className={styles.closeButton} onClick={handleClose}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
      <div className={styles.arrow}></div>
    </div>
  );
}
